"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionHandlerUpdater = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @internal
 */
class InteractionHandlerUpdater {
    constructor(updateInteractionHandlersCallback, rollupTime) {
        this.updateInteractionHandlersCallback = updateInteractionHandlersCallback;
        this.rollupTime = rollupTime;
        this.updateInteractionHandlersImpl = rc_js_util_1._Fp.debounce(this.rollupTime, false, () => {
            if (this.incrementalUpdater.isUpdating) {
                this.incrementalUpdater.resume();
            }
            else {
                this.incrementalUpdater.beginUpdate();
            }
        });
        this.incrementalUpdater = new rc_js_util_1.IncrementalUpdater(this);
        this.plotsToUpdate = new Set();
        this.nextPlotsToUpdate = new Set();
    }
    addPlotToUpdateQueue(plot) {
        if (this.incrementalUpdater.isUpdating) {
            this.plotsToUpdate.delete(plot);
            this.nextPlotsToUpdate.add(plot);
        }
        else {
            this.plotsToUpdate.add(plot);
        }
    }
    updateInteractionHandlers() {
        if (this.incrementalUpdater.isUpdating) {
            this.incrementalUpdater.suspend();
        }
        this.updateInteractionHandlersImpl();
    }
    cancelAll() {
        this.plotsToUpdate.clear();
        this.nextPlotsToUpdate.clear();
        this.incrementalUpdater.cancel();
    }
    *incrementallyUpdate() {
        var _a;
        while (true) {
            for (const plot of this.plotsToUpdate) {
                const it = this.updateInteractionHandlersCallback(plot);
                while (!((_a = it.next().done) !== null && _a !== void 0 ? _a : false)) {
                    yield;
                    if (!this.plotsToUpdate.has(plot)) {
                        break;
                    }
                }
            }
            if (this.nextPlotsToUpdate.size === 0) {
                break;
            }
            else {
                this.swap();
            }
        }
        this.plotsToUpdate.clear();
    }
    swap() {
        const tmp = this.plotsToUpdate;
        this.plotsToUpdate = this.nextPlotsToUpdate;
        this.nextPlotsToUpdate = tmp;
        this.nextPlotsToUpdate.clear();
    }
}
exports.InteractionHandlerUpdater = InteractionHandlerUpdater;
//# sourceMappingURL=interaction-handler-updater.js.map